import React, { Component } from "react";
import PropTypes from "prop-types";

import { ButtonGroup, Button, Modal, Row } from "react-bootstrap";

import moment from "moment/moment";

import BookingButton from "./BookingButton";
import ParticipantsButton from "./ParticipantsButton";
import SportSolutionApiWrapper from "../utils/SportSolutionApiWrapper";

import "./Booking.css";

class Booking extends Component {
  constructor() {
    super();
    this.renderDays = this.renderDays.bind(this);
    this.renderEvents = this.renderEvents.bind(this);
    this.setSelectedDay = this.setSelectedDay.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalShow = this.handleModalShow.bind(this);
    this.showScheduleModal = this.showScheduleModal.bind(this);
    this.daysNum = 14;
    const days = new Array();
    for (let i = 0; i < this.daysNum; i++) {
      days.push(moment().add(i, "days"));
    }
    this.state = {
      days,
      selectedDay: 0,
      i18nKeeper: document.querySelector("#i18n").dataset,
      showModal: false,
      showSchedule: false,
      eventSchedule: "",
      activeEvent: {},
    };
  }

  componentWillMount() {
    this.props.setSelectedDate(moment().format("YYYY-MM-DD"));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.bookings) {
      this.setState({
        bookings: nextProps.bookings,
      });
    }
  }

  setSelectedDay(selectedDay, e) {
    e.preventDefault();
    this.setState({
      selectedDay: selectedDay,
    });
    const selectedDate = this.state.days[selectedDay].format("YYYY-MM-DD");
    this.props.setSelectedDate(selectedDate);
  }

  eventClassName(event) {
    const cap = event.capacity;
    const booked = cap - event.free_space;
    const percent = Math.floor((100 / cap) * booked);
    if (percent < 60) return "text-success";
    if (percent >= 60 && percent < 100) return "text-warning";
    if (percent >= 100) return "text-danger";
    return "text-primary";
  }

  bookingButton(event) {
    if (this.props.user.username)
      return (
        <BookingButton
          booking={this.props.bookings[event.id]}
          getBookings={this.props.getBookings}
          user={this.props.user}
          event={event}
          popup={this.props.popup}
        />
      );
  }

  participantsButton(event) {
    if (this.props.user.username)
      return <ParticipantsButton event={event} user={this.props.user} />;
  }

  scheduleButton(event) {
    if (event.event_schedule_id && event.ss_event_category_id)
      return (
        <div>
          <Button onClick={e => this.showScheduleModal(e, event)}>🗓</Button>
        </div>
      );

    return <span />;
  }

  showScheduleModal(e, event) {
    const ssaw = new SportSolutionApiWrapper();
    const that = this;
    ssaw.schedule(event.ss_event_category_id, event.event_schedule_id, function(resp) {
      that.setState({ eventSchedule: resp.event_schedule });
      that.setState({ showSchedule: true });
      that.setState({ activeEvent: event });
    });
  }

  eventBookingRow(event) {
    if (this.props.user.username)
      return (
        <td>
          {this.bookingButton(event)}
          {this.participantsButton(event)}
          {this.scheduleButton(event)}
        </td>
      );

    return (
      <td>
        <Button href="#" onClick={e => this.handleModalShow()} className="btn">
          {this.state.i18nKeeper.anonymousSignUp}
        </Button>
      </td>
    );
  }

  eventBookingHeader() {
    return <th>{this.state.i18nKeeper.options}</th>;
  }

  eventFreeSpace(event) {
    if (this.props.user.username) {
      return (
        <td>
          <strong className={this.eventClassName(event)}>
            {event.free_space} {this.state.i18nKeeper.outOf} {event.capacity}
          </strong>
        </td>
      );
    }
  }

  eventFreeSpaceHeader() {
    if (this.props.user.username) {
      return <th>{this.state.i18nKeeper.freePlaces}</th>;
    }
  }

  handleModalClose() {
    this.setState({ showModal: false });
    this.setState({ showSchedule: false });
    this.setState({ eventSchedule: "" });
  }

  handleModalShow() {
    this.setState({ showModal: true });
  }

  renderDays() {
    const days = new Array();
    for (let i = 0; i < this.daysNum; i++) {
      days.push(
        <Button
          href="#"
          key={i}
          onClick={e => this.setSelectedDay(i, e)}
          className={this.state.selectedDay == i ? "day active" : "day"}
        >
          {this.state.days[i].format("ddd")}
          <br />
          <strong>{this.state.days[i].format("D")}</strong>
          <br />
          <small>{this.state.days[i].format("MMM")}</small>
        </Button>,
      );
    }
    return days;
  }

  renderEvents() {
    if (this.props.events && this.props.events.length > 0) {
      let events = new Array();
      for (let event of this.props.events) {
        events.push(
          <tr key={event.id}>
            <td>
              {event.start_hour}:{event.start_minute} - {event.end_hour}:{event.end_minute}
            </td>
            <td>{event.name}</td>
            <td>{event.instructor}</td>
            {this.eventFreeSpace(event)}

            {this.eventBookingRow(event)}
          </tr>,
        );
      }
      return events;
    }
    return <tr />;
  }

  render() {
    // require(`moment/locale/da`);
    return (
      <Row className="booking">
        <div className="calendar">
          <ButtonGroup justified>{this.renderDays()}</ButtonGroup>
        </div>
        <div className="classes-table">
          <table>
            <thead>
              <tr>
                <th>{this.state.i18nKeeper.hours}</th>
                <th>{this.state.i18nKeeper.class}</th>
                <th>{this.state.i18nKeeper.trainer}</th>
                {this.eventFreeSpaceHeader()}
                {this.eventBookingHeader()}
              </tr>
            </thead>
            <tbody>{this.renderEvents()}</tbody>
          </table>
        </div>
        <Modal show={this.state.showModal} onHide={this.handleModalClose} className="booking-modal">
          <Modal.Header closeButton>
            <Modal.Title>{this.state.i18nKeeper.anonymousSignUp}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p
              dangerouslySetInnerHTML={{
                __html: this.state.i18nKeeper.anonymousModalContent,
              }}
            ></p>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showSchedule}
          onHide={this.handleModalClose}
          className="booking-modal schedule-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.activeEvent.name} - {this.state.eventSchedule.schedule_date}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p
              dangerouslySetInnerHTML={{
                __html: this.state.eventSchedule.schedule,
              }}
            ></p>
          </Modal.Body>
        </Modal>
      </Row>
    );
  }
}

Booking.propTypes = {
  events: PropTypes.array.isRequired,
  bookings: PropTypes.object.isRequired,
};

export default Booking;
